import React from 'react'
import { View } from 'react-native'

import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import { useTranslation } from 'react-i18next'
import { StepOptions } from '@order/steps/types'
import useColor from 'hooks/useColor'

import OptionTinting from './Option/OptionTinting'

interface Props {
  title?: string
  desc?: string
  options: StepOptions
  color: string | undefined
}

export default function TintingTemplate({
  title,
  desc,
  options,
  ...props
}: Props) {
  const { t } = useTranslation(['ui'])
  const color = useColor(props.color)

  return (
    <Page stage="configuration">
      <Header title={title} desc={desc} />
      <View className="flex gap-8 px-8 pb-8">
        {options.map((option) => (
          <OptionTinting key={option.id} option={option} colorConfig={color} />
        ))}
      </View>
    </Page>
  )
}
